export default __webpack_public_path__ + "5e9884fe0a8ae57d41774a8755af8636.png";